<template>
    <div class="container" style="margin-bottom:20px">
        <div class="layout">
            <div class="container-inner clearfix mt25">
                <div class="list-tit">
                    <h2><span>用户登录</span></h2>
                </div>
                <div class="regform clearfix">
                    <div class="fl">
                        <div class="form-horizontal">
                            <div class="alert alert-error hidden"></div>

                            <div class="control-group">
                                    {{$store.state.account}}
                                    {{$store.state.sid}}

                                <label class="control-label" for="account">账号</label>
                                <div class="controls">
                                    <input name="account" type="text" v-model="account" id="account" class="input-medium" placeholder="请输入账号">
                                </div>
                            </div>
                            <div class="control-group">
                                <label class="control-label" for="password">密码</label>
                                <div class="controls">
                                    <input name="txtPwd" type="password" v-model="password" id="password" class="input-medium" maxlength="18" placeholder="请输入密码">
                                </div>
                            </div>

                            <div class="control-group">
                                <label class="control-label"></label>
                                <div class="controls">
                                    <input type="submit" name="btnOk" value="登录" @click="login" id="btnOk" class="btn submit">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fr">
                        <p>没有账号 ？<br>请点击 <router-link class="login" :to="'/register/'">注册</router-link></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import { mapMutations } from 'vuex';
    export default {
        name: 'UserLogin',
        data(){
            return{
                account:'',
                password:''
            }
        },
        methods:{
            ...mapMutations(['setUserInfo']),
            login:function () {
                let that = this;
                if(!that.account){
                    alert('请填写账号');
                    return;
                }
                if(!that.password){
                    alert('请填写密码');
                    return;
                }
                let data = {
                    account:that.account,
                    password:that.password,
                };
                that.$http.post(this.$api.userLogin.url,{},data).then(result => {
                    console.log(result);
                    if(result.status==200){
                        sessionStorage.setItem('userinfo',JSON.stringify(result.data));
                        that.setUserInfo(result.data)
                        alert('登录成功');
                        //返回首页
                        that.$router.push({name: 'Home'});
                    }else{
                        alert(result.info);
                    }
                });
            }
        },
        computed: {

        },
        mounted(){
            let res = sessionStorage.getItem('userinfo');
            if(res){
                let user = JSON.parse(res);
                console.log(user.account);
            }
        }
    }
</script>
<style>
    .page-bar{
        margin:40px;
    }
    ul,li{
        margin: 0px;
        padding: 0px;
    }
    li{
        list-style: none
    }
    .page-bar li:first-child>a {
        margin-left: 0px
    }
    .page-bar a{
        border: 1px solid #ddd;
        text-decoration: none;
        position: relative;
        float: left;
        padding: 6px 12px;
        margin-left: -1px;
        line-height: 1.42857143;
        color: #337ab7;
        cursor: pointer
    }
    .page-bar a:hover{
        background-color: #eee;
    }
    .page-bar a.banclick{
        cursor:not-allowed;
    }
    .page-bar .active a{
        color: #fff;
        cursor: default;
        background-color: #337ab7;
        border-color: #337ab7;
    }
    .page-bar i{
        font-style:normal;
        color: #d44950;
        margin: 0px 4px;
        font-size: 12px;
    }
</style>